import { gridSizeMdLg6, formatDate, ROUTER_PATHS, useTableFilter, EstadoTomaFisicaENUM } from "@/shared";
import { useFetchUbicacionProductosEnabled } from "@/shared/actions/erp";
import { useFetchPostTomaFisica, useFetchPutTomaFisica } from "@/shared/actions/erp/contabilidad/toma_fisica.actions";
import { CustomAutocomplete, CustomTextField, SingleTableBoxScene } from "@/shared/components/ui";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { IProductoTomaFisica, ITomaFisica } from "@/shared/interfaces/erp/contabilidad/toma_fisica.interface";
import { BODEGAS } from "@/shared/interfaces/erp/inventario";
import { useBodegaStore } from "@/store/erp";
import { useUiStore } from "@/store/ui";
import { Grid, Button, Paper } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFormTomaFisica from "../hook/useFormTomaFisica";


interface SaveTomaFisicaProps {
  title: string;
  enabledFilter: boolean
  dataTomaFisica?: ITomaFisica | null
}

export default function SaveTomaFisica({
  title,
  enabledFilter = false,
  dataTomaFisica
}: SaveTomaFisicaProps) {

  const { bodegas, isLoadingbodegas } = useBodegaStore();
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen)
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setAlert = useUiStore(s => s.setAlert);
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState<boolean>(enabledFilter);

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    form,
    setCantidadMap,
    cantidadMap,
    columnsTomaFisica,
  } = useFormTomaFisica({
    dataTomaFisica
  })

  const {
    control,
    reset,
    formState: { errors }
  } = form


  const {
    isLoading,
    isRefetching,
    data
  } = useFetchUbicacionProductosEnabled({
    params: {
      bodega: form.getValues().bodega,
      //ubicacion: form.getValues().ubicacion,
      producto: form.getValues().producto ?? '',
      estado: form.getValues().estado,
      page: pageIndex + 1,
      page_size: pageSize,
    },
    enabled: enabled
  })

  const {
    mutateAsync: mutatePostAsyncTomaFisica
  } = useFetchPostTomaFisica({
    navigate,
    returnUrl: `${ROUTER_PATHS.inventario.tomaFisicaHistorialNav}`
  })

  const {
    mutateAsync: mutateAsyncPutTomaFisica
  } = useFetchPutTomaFisica({
    navigate,
    returnUrl: `${ROUTER_PATHS.inventario.tomaFisicaHistorialNav}`
  })


  return (
    <>
      <SingleTableBoxScene
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.tomaFisicaHistorialNav}
        title={title}
        visibleReport={false}
        num_referencia={form.getValues().numero_referencia}
        py={3}
      >
        <Grid container spacing={3}
          justifyContent={'center'}
        >
          <Grid item xs={6}>
            <Grid container spacing={3}>

              <CustomTextField
                required={false}
                size={gridSizeMdLg6}
                disabled={true}
                control={form.control}
                name="fecha_toma_fisica"
                label={'Fecha toma fisica'}
                error={form.formState.errors.fecha_toma_fisica}
                defaultValue={formatDate(new Date)}
                helperText={form.formState.errors.fecha_toma_fisica?.message}
              />

              <CustomAutocomplete<BODEGAS>
                required={false}
                size={gridSizeMdLg6}
                label={'Bodega'}
                name="bodega"
                options={bodegas || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={form.getValues().bodega || ''}
                isLoadingData={isLoadingbodegas}
                control={control}
                error={errors.bodega}
                helperText={errors.bodega?.message}
              />

              <CustomTextField
                required={false}
                size={gridSizeMdLg6}
                control={form.control}
                name="producto"
                label={'Codigo producto'}
                error={form.formState.errors.producto}
                defaultValue={form.getValues().producto || ''}
                helperText={form.formState.errors.producto?.message}
              />

              <CustomTextField
                disabled
                required={false}
                size={gridSizeMdLg6}
                control={form.control}
                name="centro_costo"
                label={'Centro de costo'}
                error={form.formState.errors.centro_costo}
                defaultValue={form.getValues().centro_costo || ''}
                helperText={form.formState.errors.centro_costo?.message}
              />



            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid container spacing={3}>



              <Grid item {...gridSizeMdLg6}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    reset({
                      bodega: form.getValues().bodega ?? null,
                      producto: form.getValues().producto ?? null,
                      estado: true
                    })

                    setCantidadMap({})
                    setEnabled(true)

                  }}
                >
                  Cargar productos filtrados
                </Button>
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    //setLimpiar(false)

                    reset({
                      estado: true
                    });

                    setCantidadMap({});
                    setEnabled(true);
                  }}
                >
                  Cargar todos los productos
                </Button>
              </Grid>

              <Grid item {...gridSizeMdLg6}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="success"
                  onClick={() => {

                    const esJsonVacio = Object.keys(cantidadMap).length === 0;

                    if (esJsonVacio) return;

                    setConfirmDialogIsOpen(true);

                    setConfirmDialog({
                      isOpen: true,
                      subtitle: "Algunos inventariables tienen valores ingresados. Una vez que confirmes, estos valores se restablecerán a cero. ¿Estás seguro de que deseas cambiar el valor ingresado?",
                      title: "Confirmar",
                      onConfirm: () => {
                        setCantidadMap({})
                        setConfirmDialogIsOpen(false);

                      },
                      onClose() {
                        setConfirmDialogIsOpen(false);
                      },
                    });

                  }}
                >
                  Poner todos los productos en 0
                </Button>
              </Grid>


              <Grid item {...gridSizeMdLg6}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="error"
                  onClick={() => {

                    setConfirmDialog({
                      isOpen: true,
                      subtitle: "Toda la información ingresada se perderá. ¿Estás seguro de que deseas continuar?",
                      title: "Confirmar",
                      onConfirm: () => {
                        setConfirmDialogIsOpen(false);
                        setPagination({ pageIndex: 0, pageSize: 10 })
                        setCantidadMap({})
                        setEnabled(true)
                        reset({
                          bodega: null,
                          producto: null,
                          estado: false
                        })
                      },
                      onClose() {
                        setConfirmDialogIsOpen(false);
                      },
                    });


                  }}
                >
                  Borrar todo
                </Button>
              </Grid>


            </Grid>

          </Grid>

          {/* <div className="linea"></div> */}
          <Grid item xs={12}>

            <Paper>
              <SampleTablePagination<IProductoTomaFisica>
                columns={columnsTomaFisica}
                data={data?.data.data as any ?? []}
                rowCount={data?.data?.count ?? 0}
                setPagination={setPagination}
                pagination={pagination}
                rowNumber={true}
                isLoading={isLoading || isRefetching}
              />
            </Paper>
          </Grid>

          <Grid item xs={10}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => {

                    if (!dataTomaFisica) {
                      navigate(`${ROUTER_PATHS.inventario.tomaFisicaHistorialNav}`);
                      return
                    }

                    setConfirmDialogIsOpen(true);
                    setConfirmDialog({
                      isOpen: true,
                      subtitle: "Si cancelas una toma física, el cambio será irreversible. ¿Estás seguro de que deseas cancelarla?",
                      title: "Confirmar",
                      onConfirm: async () => {
                        setCantidadMap({})
                        setConfirmDialogIsOpen(false);
                        await mutateAsyncPutTomaFisica({
                          id: dataTomaFisica.id_toma_fisica,
                          data: {
                            estado_solicitud: EstadoTomaFisicaENUM.CANCELADO
                          }
                        })
                      },
                      onClose() {
                        setConfirmDialogIsOpen(false);
                      },
                    });
                  }}
                >
                  Cancelar
                </Button>
              </Grid>

              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="outlined"
                >
                  Conciliar
                </Button>
              </Grid>

              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => {

                    const esJsonVacio = Object.keys(cantidadMap).length === 0;

                    if (esJsonVacio) {
                      return setAlert(true, 'Ingresar inventariables.', AlertSeverityEnum.info);
                    }

                    setConfirmDialogIsOpen(true);

                    setConfirmDialog({
                      isOpen: true,
                      subtitle: "Al enviar, se actualizará el inventariable en el que se hayan realizado cambios. Este proceso es irreversible. ¿Estás seguro de que deseas continuar?",
                      title: "Confirmar",
                      onConfirm: async () => {
                        setCantidadMap({})
                        setConfirmDialogIsOpen(false);

                        const arrayResult = Object.values(cantidadMap) as any;

                        if (dataTomaFisica) {
                          await mutateAsyncPutTomaFisica({
                            id: dataTomaFisica.id_toma_fisica,
                            data: {
                              bodega: form.getValues().bodega,
                              producto: form.getValues().producto,
                              productos: arrayResult,
                              estado_solicitud: EstadoTomaFisicaENUM.FINALIZADO
                            }
                          })

                          return;
                        }

                        await mutatePostAsyncTomaFisica({
                          data: {
                            bodega: form.getValues().bodega,
                            producto: form.getValues().producto,
                            productos: arrayResult,
                            estado_solicitud: EstadoTomaFisicaENUM.FINALIZADO
                          }
                        })

                      },
                      onClose() {
                        setConfirmDialogIsOpen(false);
                      },
                    });


                  }}
                >
                  Enviar
                </Button>
              </Grid>

              <Grid item xs={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={async () => {

                    const arrayResult = Object.values(cantidadMap) as any;

                    if (dataTomaFisica) {
                      await mutateAsyncPutTomaFisica({
                        id: dataTomaFisica.id_toma_fisica,
                        data: {
                          ...form.getValues(),
                          productos: arrayResult,
                          estado_solicitud: EstadoTomaFisicaENUM.BORRADOR
                        }
                      })
                      return;
                    }


                    await mutatePostAsyncTomaFisica({
                      data: {
                        bodega: form.getValues().bodega,
                        producto: form.getValues().producto,
                        productos: arrayResult,
                        estado_solicitud: EstadoTomaFisicaENUM.BORRADOR
                      }
                    })
                  }}
                >
                  Guardar borrador
                </Button>
              </Grid>

            </Grid>

          </Grid>
        </Grid>

      </SingleTableBoxScene>
    </>
  );

}
